export default __webpack_public_path__ + "static/039-eafd1eebb29d0110c5a3690f6347d494.png";